<div [hidden]="!show">
    <div class="progress-loader">
        <div class="wrapper">
            <mat-spinner></mat-spinner>
            <!-- <div class="ball-scale-multiple">
            </div> -->
        </div>  
    </div>  
</div>